module.exports = __webpack_public_path__ + "img/symbol_16.6180ec8a.png";